import PropTypes from 'prop-types';
import React from 'react';
import slugify from 'slugify';

const SlugWidget = (props) => {
  const { onChange, value } = props;
  return (
    <div>
      <input
        value={value}
        className="form-control"
        onChange={e =>
          onChange(
            slugify(e.target.value, {
              replacement: '-', // replace spaces with replacement
              remove: null, // regex to remove characters
              lower: true, // result in lower case
            }),
          )
        }
      />
    </div>
  );
};

SlugWidget.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: PropTypes.object, //eslint-disable-line
  value: PropTypes.number,
};

SlugWidget.defaultProps = {
  options: {},
  value: undefined,
};

export default SlugWidget;



// WEBPACK FOOTER //
// ./src/byob-cms/src/AppLib/formLib/SlugWidget.js